import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
// Dashboard
import Main from "../views/Main.vue";
import Profile from "@/components/users/Profile.vue";
import NewProject from "@/components/projects/NewProject.vue";
import CustomerInformation from "@/components/projects/cards/CustomerInformation.vue";
import Scope from "@/components/projects/cards/Scope.vue";
import Documents from "@/components/projects/cards/Documents.vue";
import File from "@/components/projects/cards/File.vue";
import InternalFiles from "@/components/projects/cards/InternalFile.vue";
import Dasboard from "@/components/dashboard/Dasboard.vue";
import History from "@/components/history/History.vue";
import HistoryFullView from "@/components/history/HistoryFullView.vue";
import Team from "@/components/team/Team.vue";
import RegisterMemberTeam from "@/components/team/RegisterMemberTeam.vue";
import Companies from "@/components/companies/Companies.vue";
import Activities from "@/components/activities/Activities.vue";
import Partners from "@/components/partners/Partners.vue";

// auth
import Login from "@/views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
    children: [
      {
        path: "/settings",
        name: "Settings",
        component: Profile,
      },
      {
        path: "/newproject",
        name: "NewProject",
        component: NewProject,
      },
      {
        path: "/newproject/:id/custumer",
        name: "CustomerInformation",
        component: CustomerInformation,
      },
      {
        path: "/newproject/:id/scope",
        name: "ScopeNewProject",
        component: Scope,
      },
      {
        path: "/newproject/:id/files",
        name: "FileNewProject",
        component: File,
      },
      {
        path: "/newproject/:id/internalfiles",
        name: "FileInternalNewProject",
        component: InternalFiles,
      },
      {
        path: "/newproject/:id/documents",
        name: "DocumentsNewProject",
        component: Documents,
      },
      {
        path: "/dashboard",
        alias: "/",
        name: "Dashboard",
        component: Dasboard,
      },
      {
        path: "/history",
        name: "History",
        component: History,
      },
      {
        path: "/history/:id",
        name: "HistoryFullView",
        component: HistoryFullView,
      },
      {
        path: "/team",
        name: "Team",
        component: Team,
      },
      {
        path: "/team/register",
        name: "RegisterMemberTeam",
        component: RegisterMemberTeam,
      },
      {
        path: "/companies",
        name: "Companies",
        component: Companies,
      },
      {
        path: "/activities",
        name: "Activities",
        component: Activities,
      },
      {
        path: "/partners",
        name: "Partners",
        component: Partners,
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = localStorage.getItem("authToken");
  const isUserLoaded = store.getters.isUserLoaded;
  const hasAcceptedTerms = store.getters.hasAcceptedTerms;

  if (requiresAuth && !isAuthenticated) {
    if (to.name === "Login") {
      next();
    } else {
      next({ name: "Login" });
    }
  } else if (requiresAuth && isAuthenticated && !isUserLoaded) {
    try {
      await store.dispatch("authenticateAndLoadUser", true);
      if (!hasAcceptedTerms) {
        next({ name: "Login" });
      } else {
        next({ name: "Dashboard" });
      }
      if (to.name === "Dashboard") {
        next();
      } else {
        next({ name: "Dashboard" });
      }
    } catch (error) {
      next({ name: "Login" });
    }
  } else if (!requiresAuth && isAuthenticated && hasAcceptedTerms) {
    next({ name: "Dashboard" });
  } else if (!requiresAuth && isAuthenticated && !hasAcceptedTerms) {
    store.commit("resetState");
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
